import Layout from '@layout/Index'

export const invoiceApply = [
  {
    path: '/invoice-apply',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "invoice-apply-table" */ './pages/InvoiceApplyNewTable.vue'),
        name: '开票管理',
        meta: {
          is_pre_received: false,
          title: '开票管理',
          type: 'table',
        },
      },
      {
        path: 'approval',
        component: () => import(/* webpackChunkName: "invoice-apply-approval-table" */ './pages/InvoiceApplyNewTable.vue'),
        name: '开票待审批列表',
        meta: {
          is_pre_received: false,
          title: '开票待审批列表',
          type: 'approval',
        },
      },
      {
        path: 'detail-redirect/:id',
        component: () => import(/* webpackChunkName: "invoice-detail-redirect" */ './pages/InvoiceDetailRedirect.vue'),
        name: '开票详情跳转页面',
        meta: {
          title: '跳转开票详情',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "invoice-apply-detail-page" */ './pages/InvoiceApplyNewDetail.vue'),
        name: '开票详情',
        meta: {
          title: '开票详情',
          isFinancePage: false,
        },
      },
      {
        path: 'finance/detail/:id',
        component: () => import(/* webpackChunkName: "invoice-apply-detail-page" */ './pages/InvoiceApplyNewDetail.vue'),
        name: '开票详情',
        meta: {
          title: '开票单详情页',
          isFinancePage: true,
        },
      },
      {
        path: 'review/:id',
        component: () => import(/* webpackChunkName: "invoice-apply-review-page" */ './pages/InvoiceApplyReview.vue'),
        name: '开票审批页面(旧)',
        meta: {
          title: '开票审批页面(旧)',
        },
      },
      {
        path: 'review/bu-review/:id',
        component: () => import(/* webpackChunkName: "InvoiceBuReview" */ './pages/approve/InvoiceBuReview.vue'),
        name: '开票BU审批页面',
        meta: {
          title: '开票BU审批页面',
        },
      },
      {
        path: 'review/finance-approve/:id',
        component: () => import(/* webpackChunkName: "InvoiceFinanceApprove" */ './pages/approve/InvoiceFinanceApprove.vue'),
        name: '开票财务审批页面',
        meta: {
          title: '开票财务审批页面',
          isFinancePage: true
        },
      },
      {
        path: 'review/complete/:id',
        component: () => import(/* webpackChunkName: "InvoiceApproveComplete" */ './pages/approve/InvoiceApproveComplete.vue'),
        name: '完成开票',
        meta: {
          title: '完成开票',
        },
      },
      {
        path: 'review/signed-off/:id',
        component: () => import(/* webpackChunkName: "InvoiceSignedOff" */ './pages/apply/InvoiceSignedOff.vue'),
        name: '开票客户签收页面',
        meta: {
          title: '开票客户签收页面',
        },
      },
      {
        path: 'review/return/:id',
        component: () => import(/* webpackChunkName: "InvoiceReturnTicket" */ './pages/apply/InvoiceReturnTicket.vue'),
        name: '开票退票申请页面',
        meta: {
          title: '开票退票申请页面',
        },
      },
      {
        path: 'review/abandon/:id',
        component: () => import(/* webpackChunkName: "InvoiceAbandonApply" */ './pages/apply/InvoiceAbandonApply.vue'),
        name: '开票放弃申请页面',
        meta: {
          title: '开票放弃申请页面',
        },
      },
      {
        path: 'review/void/:id',
        component: () => import(/* webpackChunkName: "InvoiceApproveVoid" */ './pages/approve/InvoiceApproveVoid.vue'),
        name: '开票作废审批',
        meta: {
          title: '开票作废审批',
          isFinancePage: true
        },
      },
      {
        path: 'review/bu-deduct/:id',
        component: () => import(/* webpackChunkName: "InvoiceDeductBuReview" */ './pages/approve/InvoiceDeductBuReview.vue'),
        name: '预收款开票-抵扣BU审批页面',
        meta: {
          title: '预收款开票-抵扣BU审批页面',
        },
      },
      {
        path: 'review/waiver-deduct/:id',
        component: () => import(/* webpackChunkName: "InvoiceWaiverDeduct" */ './pages/apply/InvoiceWaiverDeduct.vue'),
        name: '预收款开票-放弃抵扣页面',
        meta: {
          title: '预收款开票-放弃抵扣页面',
        },
      },
      {
        path: 'review/deduct-apply/:id',
        component: () => import(/* webpackChunkName: "InvoiceDeductApplyPage" */ './pages/apply/InvoiceDeductApplyPage.vue'),
        name: '预收款开票-抵扣申请页面',
        meta: {
          title: '预收款开票-抵扣申请页面',
        },
      },
      {
        path: 'review/deduct-finance-approve/:id',
        component: () => import(/* webpackChunkName: "InvoiceDeductFinReview" */ './pages/approve/InvoiceDeductFinReview.vue'),
        name: '预收款开票-抵扣财务审批页面',
        meta: {
          title: '预收款开票-抵扣财务审批页面',
          isFinancePage: true
        },
      },
      {
        path: 'split/table',
        component: () => import(/* webpackChunkName: "InvoiceSplitTable" */ './pages/InvoiceSplitTable.vue'),
        name: '拆分发票列表',
        meta: {
          title: '拆分发票列表',
        },
      },
      {
        path: 'pre-received/table',
        component: () => import(/* webpackChunkName: "invoice-apply-pre-table" */ './pages/InvoiceApplyNewTable.vue'),
        name: '预收款开票管理',
        meta: {
          is_pre_received: true,
          title: '预收款开票管理',
          type: 'pre_received',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "invoice-apply-form" */ './pages/InvoiceApplyForm.vue'),
        name: '添加开票申请',
        meta: {
          title: '添加开票申请',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "invoice-apply-update-form" */ './pages/InvoiceApplyForm.vue'),
        name: '修改开票申请',
        meta: {
          title: '修改开票申请',
        },
      },
      {
        path: 'approve/table',
        component: () => import(/* webpackChunkName: "invoice-approve-table" */ './pages/InvoiceApproveTable.vue'),
        name: '开票审批',
        meta: {
          is_pre_received: false,
          title: '开票审批',
        },
      },
      {
        path: 'approve/pre-received/table',
        component: () => import(/* webpackChunkName: "invoice-approve-pre-received-table" */ './pages/InvoiceApproveTable.vue'),
        name: '预收款开票审批',
        meta: {
          is_pre_received: true,
          title: '预收款开票审批',
        },
      },
      {
        path: 'received-payment/table/type/:type',
        component: () => import(/* webpackChunkName: "received-payment-table" */ './pages/ReceivedPaymentTable.vue'),
        name: '回款管理(旧)',
      },
      {
        path: 'received-payment-detail/:id/type/:type',
        component: () => import(/* webpackChunkName: "received-payment-detail-table" */ './pages/ReceivedPaymentDetailTable.vue'),
        name: '回款详情(旧)',
      },
      {
        path: 'received-payment-log/:id',
        component: () => import(/* webpackChunkName: "received-payment-log-table" */ './pages/ReceivedPaymentLogTable.vue'),
        name: '回款日志(旧)',
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/invoice-apply/invoice-apply.route.js